module.exports = __webpack_public_path__ + "UX27.png?91d72b568c004350e20daa6492c10960";


//////////////////
// WEBPACK FOOTER
// ./src/assets/UX27.png
// module id = 76
// module chunks = 0